import { TableComment } from "../../../general/src/TableComment";
import { DetentionHistoryTable } from "../DetentionHistoryTable";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDefinition extends Layout {
    buttonCopyDetentionDef: Button;
    checkboxAlwaysPay: Checkbox;
    checkboxApplyToConfirmedAppts: Checkbox;
    checkboxBillingApproval: Checkbox;
    checkboxLateArrivals: Checkbox;
    checkboxRequireAuth: Checkbox;
    checkboxUseActualTime: Checkbox;
    dataheader1: DataHeader;
    labelArrival: Label;
    labelCarriers: Label;
    labelCharge: Label;
    labelChargeFreeTime: Label;
    labelCompDrivers: Label;
    labelDepart: Label;
    labelDoNot: Label;
    labelH: Label;
    labelOwnerOps: Label;
    labelPayementFree: Label;
    labelSetting: Label;
    labelSingleComp: Label;
    labelTeamComp: Label;
    labelWarning: Label;
    labelme: Label;
    layoutDetentionHistoryTable: DetentionHistoryTable;
    layoutTableComment: TableComment;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel15: Panel;
    panel16: Panel;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel9: Panel;
    sourceComments: DataSource;
    sourceDetentionDef: DataSource;
    sourceDetentionDefChg: DataSource;
    sourceDetentionHistoryLookup: DataSource;
    switchActive: Switch;
    switchGlobalDef: Switch;
    tabArrival: Tab;
    tabCharge: Tab;
    tabCharges: Tab;
    tabComments: Tab;
    tabDeparture: Tab;
    tabDriverPay: Tab;
    tabEmailOver: Tab;
    tabGeneral: Tab;
    tabHistory: Tab;
    tabNotification: Tab;
    tabText: Tab;
    tabWarning: Tab;
    tableCharges: Table;
    tabset1: Tabset;
    tabsetText: Tabset;
    textboxAppliesTo: Textbox;
    textboxC: Textbox;
    textboxCEarningCode: Textbox;
    textboxCMaxPayAmount: Textbox;
    textboxCPayOption: Textbox;
    textboxCarrier_: Textbox;
    textboxChargeText: Textbox;
    textboxCmpDriverEarningCode: Textbox;
    textboxCmpDriverMaxPayAmount: Textbox;
    textboxCmpDriverMethod: Textbox;
    textboxCmpDriverPayRate: Textbox;
    textboxCmpPayOption: Textbox;
    textboxCmpTeamEarningCode: Textbox;
    textboxCmpTeamMaxPayAmount: Textbox;
    textboxCmpTeamMethod: Textbox;
    textboxCmpTeamPayRate: Textbox;
    textboxCommodityId: Textbox;
    textboxContactName: Textbox;
    textboxCustomerId: Textbox;
    textboxDepartText: Textbox;
    textboxDescr: Textbox;
    textboxEAminutes: Textbox;
    textboxEarlyArrivalHours: Textbox;
    textboxEffectiveDate: Textbox;
    textboxEmailBilling: Textbox;
    textboxEmailCcList: Textbox;
    textboxEmailErrors: Textbox;
    textboxEmailList: Textbox;
    textboxEmailProfileId: Textbox;
    textboxExpirationDate: Textbox;
    textboxFreeTimeHours: Textbox;
    textboxFreeTimeMinutes: Textbox;
    textboxFreqChgHours: Textbox;
    textboxFreqChgMinutes: Textbox;
    textboxFreqWarnHours: Textbox;
    textboxFreqWarnMinutes: Textbox;
    textboxGracePeriod: Textbox;
    textboxNotifyArrival: Textbox;
    textboxNotifyCharge: Textbox;
    textboxNotifyDeparture: Textbox;
    textboxNotifyWarning: Textbox;
    textboxO: Textbox;
    textboxOrderTypeId: Textbox;
    textboxOwnopEarningCode: Textbox;
    textboxOwnopMaxPayAmount: Textbox;
    textboxOwnop_: Textbox;
    textboxOwnop_payRate: Textbox;
    textboxPayFreeTimeHours: Textbox;
    textboxPayFreeTimeMinutes: Textbox;
    textboxPriority: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxRoundingOption: Textbox;
    textboxStopLocationId: Textbox;
    textboxTextArrival: Textbox;
    textboxTextWarning: Textbox;
    textboxWarnHours: Textbox;
    textboxWarnMinutes: Textbox;
}
